// Autogenerated file to create a WebPack context to later load in translations files
// Please don't modify, and let the magic do it's work
import { setup as setupI18n } from "@eb/i18n";
setupI18n(require.context("./translations", true, /\.json$/));
